module.exports = __webpack_public_path__ + "img/big_1_69.44e0eb00.png";